import React, { useState } from "react";
import "./BankDetails.css";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown";
import CustomSwitch from "../../Components/CustomSwitch/CustomSwitch";
import Checkbox from "@mui/material/Checkbox";
import BackIcon from "../../assets/images/client-dashboard/adddepinfo-banbtnbackicon.svg";
import { useNavigate } from "react-router-dom";
const ClientDashboardAddBankDetails = () => {
  const [residentialAddresses, setResidentialAddresses] = useState([
    { year: 2020, state: "", from: "", to: "" },
  ]);
  const navigate = useNavigate();
  const addResidentialAddress = (index) => {
    const newYear = residentialAddresses[index]?.year + 1;
    if (!residentialAddresses.some((address) => address.year === newYear)) {
      setResidentialAddresses((prevAddresses) => [
        ...prevAddresses,
        {
          year: newYear,
          state: "",
          from: "",
          to: "",
        },
      ]);
    } else {
      // Handle the case when the year already exists (e.g., show an error message)
      // You can add your own logic here
    }
  };
  const removeResidentialAddress = (index) => {
    setResidentialAddresses((prevAddresses) =>
      prevAddresses.filter((_, i) => i !== index)
    );
  };
  return (
    <div className="clientdashboard__bankdetails_section">
      <div className="clientdashboard__bankdetails_wrapper">
        <div className="clientdashboard__bankdetails_innersection">
          <div className="clientdashboard__bankdetails_inrsecheader">
            Bank Information for Direct Deposit
          </div>
          <div className="clientdashboard__bankdetails_inrsecbody">
            <div className="clientdashboard__bankdetails_inrsecrow">
              <div className="clientdashboard__bankdetails_inrseccolleft">
                <label className="clientdashboard__bankdetails_inputlbl">
                  Name of the account holder
                </label>
                <input
                  type="text"
                  className="clientdashboard__bankdetails_inputfield"
                  placeholder="Name of the account holder"
                />
              </div>
              <div className="clientdashboard__bankdetails_inrseccol">
                <label className="clientdashboard__bankdetails_inputlbl">
                  Name of the bank
                </label>
                <input
                  type="text"
                  className="clientdashboard__bankdetails_inputfield"
                  placeholder="Name of the bank"
                />
              </div>
            </div>
            <div className="clientdashboard__bankdetails_inrsecrow">
              <div className="clientdashboard__bankdetails_inrseccolleft">
                <label className="clientdashboard__bankdetails_inputlbl">
                  US bank Routing number (9 digits)
                </label>
                <input
                  type="text"
                  className="clientdashboard__bankdetails_inputfield"
                  placeholder="US bank Routing number (9 digits)"
                />
              </div>
              <div className="clientdashboard__bankdetails_inrseccol">
                <label className="clientdashboard__bankdetails_inputlbl">
                  US Bank Account Number
                </label>

                <input
                  type="text"
                  className="clientdashboard__bankdetails_inputfield"
                  placeholder="US Bank Account Number"
                />
              </div>
            </div>
            <div className="clientdashboard__bankdetails_inrsecrow">
              <div className="clientdashboard__bankdetails_inrseccolleft">
                <label className="clientdashboard__bankdetails_inputlbl">
                  Type of Account
                </label>
                <CustomDropdown
                  options={["Savings Account", "Current"]}
                  customStyles={{
                    height: 60,
                    border: "1px solid lightgrey",
                    marginTop: 5,
                  }}
                />
              </div>
              <div className="clientdashboard__bankdetails_inrseccol"></div>
            </div>
          </div>
        </div>
        <div
          className="clientdashboard__depndtinfo_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="clientdashboard__depndtinfo_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="clientdashboard__depndtinfo_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
      </div>

      <br />
      <div className="clientdashboard__bankdetails_wrapper">
        <div className="clientdashboard__bankdetails_bottombtns">
          <button className="clientdashboard__bankdetails_bottombtn1">
            Save
          </button>
          <button className="clientdashboard__bankdetails_bottombtn2">
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardAddBankDetails;
